export interface IFilterDef {
    type: IFilterDefTypeEnum;
    args?: Array<IFilterDef>;
    arg?: IFilterDef;
    propertyName?: string;
    literal?: any;
    // BBOX filter type property
    coordinates?: string;
    // XML filter type property
    value?: string;
}

export enum IFilterDefTypeEnum {
    Or = 'Or',
    And = 'And',
    Not = 'Not',
    PropertyIsEqualTo = 'PropertyIsEqualTo',
    PropertyIsGreaterThan = 'PropertyIsGreaterThan',
    PropertyIsGreaterThanOrEqualTo = 'PropertyIsGreaterThanOrEqualTo',
    PropertyIsLessThan = 'PropertyIsLessThan',
    PropertyIsLessThanOrEqualTo = 'PropertyIsLessThanOrEqualTo',
    PropertyIsNotEqualTo = 'PropertyIsNotEqualTo',
    PropertyIsLike = 'PropertyIsLike',
    PropertyIsNull = 'PropertyIsNull',
    BBOX = 'BBOX',
    XML = 'XML',
}